import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Pagetitle from "../Components/Pagetitle";
import { getData } from "../Api";

const TrackOrder = () => {
  const [orderId, setOrderId] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleTrack = async () => {
    if (!orderId.trim()) {
      setError("Please enter a valid order ID.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const data = await getData(`/orders/${orderId}`);

      if (data.success) {
        navigate(`/orders/${orderId}`);
      } else {
        setError("❌ Order not found. Please check your order ID.");
      }
    } catch (err) {
      console.error("Track order error:", err);
      setError("⚠️ Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <main className="container-fluid">
        <Header />
        <Pagetitle />

        {/* Search Section */}
        <div className="row justify-content-center text-center py-5">
          <div className="text-center about-title">
            <h1>Track Your Order</h1>
            <p>Please enter your order ID below to view your order details.</p>
          </div>

          <div className="col-lg-4 col-md-6">
            <input
              type="text"
              className="form-control text-center py-3"
              placeholder="Enter your Order ID"
              value={orderId}
              onChange={(e) => setOrderId(e.target.value)}
            />

            <button
              className="btn-style1 w-100 my-3"
              onClick={handleTrack}
              disabled={loading}
            >
              {loading ? "Checking..." : "Track Order"}
            </button>

            {error && (
              <div className="alert alert-danger mt-2" role="alert">
                {error}
              </div>
            )}
          </div>
        </div>

        <Footer />
      </main>
    </>
  );
};

export default TrackOrder;
